export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更完成公告_kr-929ab7eba2599d20c1207ce41777cebe.webp";